// Minimal ``classnames`` helper — concat strings while dropping
// falsy values. We don't bring in the npm package because we only
// use ~5 % of its API.

type Value = string | number | false | null | undefined;

export function cn(...values: Value[]): string {
  return values.filter((v): v is string | number => Boolean(v)).join(' ');
}
